<template>
  <ContentWrap>
    <!-- 搜索工作栏 -->
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-240px"
          @change="handleQuery"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="通知类型" prop="type">
        <el-select
          v-model="queryParams.type"
          class="!w-240px"
          clearable
          placeholder="请选择类型"
        >
          <el-option label="入住提醒" :value="1" />
          <el-option label="退房提醒" :value="2" />
          <el-option label="清洁任务" :value="3" />
          <el-option label="维修工单" :value="4" />
          <el-option label="系统通知" :value="5" />
          <el-option label="夜审通知" :value="6" />
        </el-select>
      </el-form-item>
      <el-form-item label="阅读状态" prop="readStatus">
        <el-select
          v-model="queryParams.readStatus"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option label="未读" :value="0" />
          <el-option label="已读" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:notification:create']"
          plain
          type="primary"
          @click="openSendDialog"
        >
          <Icon class="mr-5px" icon="ep:promotion" />
          发送通知
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 通知列表 -->
  <ContentWrap>
    <el-table v-loading="loading" :data="list" :stripe="true" border>
      <el-table-column align="center" label="ID" prop="id" width="80" />
      <el-table-column align="center" label="通知类型" prop="typeLabel" width="120">
        <template #default="scope">
          <el-tag :type="getTypeTag(scope.row.type)">
            {{ getTypeLabel(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题" prop="title" min-width="160" />
      <el-table-column
        align="center"
        label="内容"
        prop="content"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column align="center" label="接收人" prop="recipientName" width="120">
        <template #default="scope">
          <span>{{ scope.row.recipientName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="阅读状态" prop="readStatus" width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.readStatus === 0" type="danger">未读</el-tag>
          <el-tag v-else type="success">已读</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="220" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:notification:query']"
            link
            type="primary"
            @click="openDetailDialog(scope.row.id)"
          >
            查看详情
          </el-button>
          <el-button
            v-if="scope.row.readStatus === 0"
            v-hasPermi="['hotel:notification:update']"
            link
            type="success"
            @click="handleMarkAsRead(scope.row.id)"
          >
            标记已读
          </el-button>
          <el-button
            v-hasPermi="['hotel:notification:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 发送通知弹窗 -->
  <Dialog v-model="sendDialogVisible" title="发送通知" width="600px">
    <el-form
      ref="sendFormRef"
      v-loading="sendFormLoading"
      :model="sendFormData"
      :rules="sendFormRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="sendFormData.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-240px"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="通知类型" prop="type">
        <el-select v-model="sendFormData.type" placeholder="请选择类型" class="!w-240px">
          <el-option label="入住提醒" :value="1" />
          <el-option label="退房提醒" :value="2" />
          <el-option label="清洁任务" :value="3" />
          <el-option label="维修工单" :value="4" />
          <el-option label="系统通知" :value="5" />
          <el-option label="夜审通知" :value="6" />
        </el-select>
      </el-form-item>
      <el-form-item label="优先级" prop="priority">
        <el-select v-model="sendFormData.priority" placeholder="请选择优先级" class="!w-240px">
          <el-option label="普通" :value="0" />
          <el-option label="重要" :value="1" />
          <el-option label="紧急" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="接收人ID" prop="recipientIds">
        <el-input
          v-model="recipientIdsInput"
          placeholder="多个ID用逗号分隔，留空则全员发送"
        />
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="sendFormData.title" placeholder="请输入通知标题" />
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          v-model="sendFormData.content"
          :rows="4"
          placeholder="请输入通知内容"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="sendFormLoading" type="primary" @click="submitSend">确 定</el-button>
      <el-button @click="sendDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <!-- 通知详情弹窗 -->
  <Dialog v-model="detailDialogVisible" title="通知详情" width="600px">
    <el-descriptions v-loading="detailLoading" :column="1" border>
      <el-descriptions-item label="ID">{{ detailData.id || '-' }}</el-descriptions-item>
      <el-descriptions-item label="通知类型">
        <el-tag :type="getTypeTag(detailData.type)">
          {{ getTypeLabel(detailData.type) }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="优先级">
        <el-tag :type="getPriorityTag(detailData.priority)">
          {{ getPriorityLabel(detailData.priority) }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="标题">{{ detailData.title || '-' }}</el-descriptions-item>
      <el-descriptions-item label="内容">{{ detailData.content || '-' }}</el-descriptions-item>
      <el-descriptions-item label="发送渠道">
        {{ getChannelLabel(detailData.channel) }}
      </el-descriptions-item>
      <el-descriptions-item label="接收人">{{ detailData.recipientName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="接收人ID">{{ detailData.recipientId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="阅读状态">
        <el-tag v-if="detailData.readStatus === 0" type="danger">未读</el-tag>
        <el-tag v-else type="success">已读</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="阅读时间">{{ detailData.readTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="业务类型">{{ detailData.bizType || '-' }}</el-descriptions-item>
      <el-descriptions-item label="业务ID">{{ detailData.bizId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</el-descriptions-item>
    </el-descriptions>
    <template #footer>
      <el-button @click="detailDialogVisible = false">关 闭</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as NotificationApi from '@/api/hotel/notification'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelNotification' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref<NotificationApi.NotificationVO[]>([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  shopId: undefined,
  type: undefined,
  readStatus: undefined
})
const queryFormRef = ref()

// 通知类型映射
const typeMap: Record<number, string> = {
  1: '入住提醒',
  2: '退房提醒',
  3: '清洁任务',
  4: '维修工单',
  5: '系统通知',
  6: '夜审通知'
}
const typeTagMap: Record<number, string> = {
  1: 'primary',
  2: 'warning',
  3: 'success',
  4: 'danger',
  5: 'info',
  6: 'primary'
}
const getTypeLabel = (type: number) => typeMap[type] || '未知'
const getTypeTag = (type: number) => typeTagMap[type] || 'info'

// 优先级映射
const priorityMap: Record<number, string> = { 0: '普通', 1: '重要', 2: '紧急' }
const priorityTagMap: Record<number, string> = { 0: 'info', 1: 'warning', 2: 'danger' }
const getPriorityLabel = (priority: number) => priorityMap[priority] || '普通'
const getPriorityTag = (priority: number) => priorityTagMap[priority] || 'info'

// 发送渠道映射
const channelMap: Record<number, string> = { 1: '站内信', 2: '短信', 3: '微信' }
const getChannelLabel = (channel: number) => channelMap[channel] || '站内信'

const getList = async () => {
  loading.value = true
  try {
    const data = await NotificationApi.getNotificationPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

// 删除
const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await NotificationApi.deleteNotification(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

// 标记已读
const handleMarkAsRead = async (id: string | number) => {
  try {
    await message.confirm('确认将该通知标记为已读？')
    await NotificationApi.markAsRead(id)
    message.success('标记已读成功')
    await getList()
  } catch {}
}

// 发送通知弹窗
const sendDialogVisible = ref(false)
const sendFormLoading = ref(false)
const sendFormRef = ref()
const recipientIdsInput = ref('')
const sendFormData = ref<NotificationApi.SendDTO>({
  shopId: undefined,
  recipientIds: [],
  type: undefined,
  title: '',
  content: '',
  channel: 1,
  priority: 0
})
const sendFormRules = reactive({
  shopId: [{ required: true, message: '店铺不能为空', trigger: 'change' }],
  type: [{ required: true, message: '通知类型不能为空', trigger: 'change' }],
  title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
  content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
})

const resetSendForm = () => {
  sendFormData.value = {
    shopId: undefined,
    recipientIds: [],
    type: undefined,
    title: '',
    content: '',
    channel: 1,
    priority: 0
  }
  recipientIdsInput.value = ''
  sendFormRef.value?.resetFields()
}

const openSendDialog = () => {
  resetSendForm()
  sendDialogVisible.value = true
}

const submitSend = async () => {
  if (!sendFormRef.value) return
  const valid = await sendFormRef.value.validate()
  if (!valid) return
  sendFormLoading.value = true
  try {
    // 解析接收人ID（逗号分隔）
    const ids = recipientIdsInput.value
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
    sendFormData.value.recipientIds = ids
    await NotificationApi.sendNotification(sendFormData.value)
    message.success('发送成功')
    sendDialogVisible.value = false
    await getList()
  } finally {
    sendFormLoading.value = false
  }
}

// 详情弹窗
const detailDialogVisible = ref(false)
const detailLoading = ref(false)
const detailData = ref<NotificationApi.NotificationVO>({} as NotificationApi.NotificationVO)

const openDetailDialog = async (id: string | number) => {
  detailDialogVisible.value = true
  detailLoading.value = true
  try {
    detailData.value = await NotificationApi.getNotification(id)
  } finally {
    detailLoading.value = false
  }
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
